import { render } from "./StatisticOnline.vue?vue&type=template&id=4fcbb46c&ts=true"
import script from "./StatisticOnline.vue?vue&type=script&lang=ts"
export * from "./StatisticOnline.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__